import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {OrganizationAccount} from "../types.ts";
import {useOrganizationAccount} from "../hooks/useOrganizationAccount.ts";
import {useParams} from "react-router-dom";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: organizationId} = useParams();

    const {
        record,
        createRecord,
    } = useOrganizationAccount();

    const seededRecord = {
        ...(record ?? {}),
        ...(organizationId ? {organizationId} : {}),
    } as OrganizationAccount;

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
